import React from 'react'
import GalleryStrip from '../../components/gallery-strip'
import Carousel from '../../components/casestudy-carousel'
import Stat from '../../components/db/blocks/stat'
import Service from '../../components/db/blocks/service'
import Summary from '../../components/summary'
import Testimonials from '../../components/testimonials'
import { Container, Row, Col } from 'reactstrap'
import Layout from '../../layout/layout'
import styled from 'styled-components'
import Img from 'gatsby-image'
const slugify = require(`slugify`)

const Stats = props => {
  var stats = []
  if (props.children) {
    stats = props.children.map(stat => {
      return (
        <div className="col-12 col-md-4 stat-wrap" key={stat.id}>
          {stat.icon ? <img src={stat.icon.file.url} className="img-fluid" alt={stat.title + 'icon'} /> : ''}
          <Stat key={stat.id} data={stat} />
        </div>
      )
    })
  }

  return <>{stats}</>
}

const Services = props => {
  var services = []
  if (props.children) {
    services = props.children.map(service => {
      return (
        <div className="col-6 col-md-12 col-holder ">
          <Service key={service.id} data={service} CaseStudy="true" />
        </div>
      )
    })
  }

  return (
    <div className="services">
      <div className="row no-gutters">{services}</div>
    </div>
  )
}

const CaseStudyEntry = ({ pageContext }) => (
  <Layout contextEntity={pageContext.entity} cssClass="caseStudies">
    <Summary data={pageContext.entity} />

    <div id="main-content">
      {pageContext.entity.brief && pageContext.entity.brief.childMarkdownRemark ? (
        <section className="section-content">
          <Container>
            <Row>
              <Col md="7">
                <div className="dyn-content">
                  <div dangerouslySetInnerHTML={{ __html: pageContext.entity.brief.childMarkdownRemark.html }} />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        ''
      )}

      {pageContext.entity.solution && pageContext.entity.solution.childMarkdownRemark ? (
        <section className="section-content solution-section">
          <Container>
            <Row>
              <Col md="7">
                <div
                  className="dyn-content"
                  dangerouslySetInnerHTML={{ __html: pageContext.entity.solution.childMarkdownRemark.html }}
                />
              </Col>
              <Col md="5">
                <Services className="col-4">{pageContext.entity.services}</Services>
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        ''
      )}

      {pageContext.entity.gallery ? <Carousel data={pageContext.entity.gallery} /> : ''}

      {pageContext.entity.stats ? (
        <section className="project-stats" id={pageContext.entity.galleryFullWidth ? 'stats-padding' : ''}>
          <Container>
            <div className="row justify-content-center">
              <Stats>{pageContext.entity.stats}</Stats>
            </div>
          </Container>
        </section>
      ) : (
        ''
      )}

      {pageContext.entity.gallery2 ? (
        <GalleryStrip
          fluid={pageContext.entity.gallery2FullWidth}
          data={pageContext.entity.gallery2}
          padding={pageContext.entity.galleryFullWidth ? 'stats-padding' : ''}
        />
      ) : (
        ''
      )}

      {pageContext.entity.testimonials ? (
        <section class="Inline">
          <div className="testimonial-section">
            <div className="quoteImages">
                  <Svg className="quote-svg" />
                  <Svg className="quote-svg quote-svg_second" />
              </div>
              <Testimonials data={pageContext.entity.testimonials} />
          </div>
        </section>
        // <section className="testimonial-section">
        //   <Container>
        //     <Row>
        //       <Col md="7">
        //         <div className="dyn-content">
        //           <Testimonials data={pageContext.entity.testimonials} />
        //         </div>
        //       </Col>
        //     </Row>
        //   </Container>
        //   <div className="quoteImages">
        //     <Svg background={quoteSVG} className="quote-svg" />
        //     <Svg background={quoteSVG} className="quote-svg" />
        //   </div>
        // </section>
      ) : (
        ''
      )}

      {pageContext.entity.gallery3 ? (
        <GalleryStrip fluid={pageContext.entity.gallery3FullWidth} data={pageContext.entity.gallery3} />
      ) : (
        ''
      )}

      {pageContext.entity.results && pageContext.entity.results.childMarkdownRemark ? (
        <section className="results">
          <Container>
            <Row>
              <Col xs="12" md="7">
                <div dangerouslySetInnerHTML={{ __html: pageContext.entity.results.childMarkdownRemark.html }} />
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        ''
      )}

      {pageContext.entity.relatedCaseStudies ? (
        <section className="PortraitBlocks">
          <Container>
            <Row>
              <div className="col-12">
                <h2>Featured case studies</h2>
              </div>
              {pageContext.entity.relatedCaseStudies.map(project => {
                var path = '/case-studies/' + slugify(project.project, { lower: true }) + '/'
                return (
                  <div className="col-md-4" key={project.id}>
                    <div className="case-study">
                      <a href={path}>
                        <Row>
                          <Col className="case-study-image">
                            <Img fluid={project.summaryImage.fluid} />
                          </Col>
                          <Col>
                            <div className="content">
                              <h2 className="h4">{project.project}</h2>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    </div>
                  </div>
                )
              })}
            </Row>
          </Container>
        </section>
      ) : (
        ''
      )}
    </div>
  </Layout>
)


const Svg = styled.div`

display: inline-block;
    background: linear-gradient(to right,#07c5d1,#f134a8);
    -moz-animation: AnimationName 10s ease infinite;
    -webkit-mask: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1OTMiIGhlaWdodD0iNDUxIiB2aWV3Qm94PSIwIDAgNTkzIDQ1MSI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIxNTkuMyUiIHgyPSIwJSIgeTE9IjU0LjA2OCUiIHkyPSI1NC4wNjglIj4KICAgICAgPHN0b3Agc3RvcENvbG9yPSIjRjAzNEE4IiBvZmZzZXQ9IjAlIiAvPgogICAgICA8c3RvcCBzdG9wQ29sb3I9IiMwN0M1RDEiIG9mZnNldD0iMTAwJSIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxwYXRoCiAgICBmaWxsPSJ1cmwoI2EpIgogICAgZmlsbFJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNMjM2LjY5NzA3LDEzLjc2NjkzMjMgQzEzMS42OTkwMzYsNDQuODQwMjA4NSAxMS40MzAyMjM2LDEyNi40MDc1NTkgMTEuNDMwMjIzNiwyNTYuOTUyMDkyIEMxMS40MzAyMjM2LDM3Ni4zMDM4MTEgODkuNTQ0MzcxNiw0MzguNzQ5MTQ0IDE2Ni42NzU1Miw0MzguNzQ5MTQ0IEMyMTkuMDQ4ODA1LDQzOC43NDkxNDQgMjU0LjIzMTAzMyw0MDcuODEzNzY3IDI1NC4yMzEwMzMsMzYxLjc1NTQ1IEMyNTQuMjMxMDMzLDMzOS44NTI0NjcgMjQxLjQ3NDkwNCwzMTguODIyODQ2IDIzNS4yMzQwMDIsMzE3Ljc4ODYwMiBDMTcyLjQzNjM1MywzMDIuOTY0NDQzIDEwNy45MjQxNzEsMjg3LjY4MDYyIDEwNy45MjQxNzEsMjE4LjM0MDMyOSBDMTA3LjkyNDE3MSwxNTIuNTE2NDY1IDE1Ni4zNDI1OTgsOTkuMTcyNDc1NiAyNTUuOTQ1NTY3LDU1LjQzNTQ2MDMgTDIzNi42OTcwNywxMy43NjY5MzIzIFogTTE2Ni42NzU1Miw0NTAuMjQwNzQxIEM4My44MjkyNTk4LDQ1MC4yNDA3NDEgMCwzODMuODY1MjgxIDAsMjU2Ljk1MjA5MiBDMCwxMTguMDQxNjc3IDEyOC4zNjE0MTEsMzIuNDI5Mjg0NiAyMzguMjc0NDQxLDEuMzU2MDA4MzYgTDI0Mi45Mzc5NzIsMC4wMjI5ODMxOTI1IEwyNzEuMjg0OTI3LDYxLjM0MjE0MDcgTDI2NS44MjEyOCw2My42NjM0NDMyIEMxNjcuMjY5ODkyLDEwNS44Mzc2MDEgMTE5LjM1NDM5NSwxNTYuNDQ2NTkxIDExOS4zNTQzOTUsMjE4LjM0MDMyOSBDMTE5LjM1NDM5NSwyNzguNTc5Mjc2IDE3Ni43MzQxMTcsMjkyLjE2MjM0MyAyMzcuNDc0MzI1LDMwNi41MjY4MzggQzI1Mi40NzA3NzksMzA5LjAwOTAyMyAyNjUuNjYxMjU3LDMzOS4wMDIwODkgMjY1LjY2MTI1NywzNjEuNzU1NDUgQzI2NS42NjEyNTcsNDEzLjg1ODM0NyAyMjQuOTQ2OCw0NTAuMjQwNzQxIDE2Ni42NzU1Miw0NTAuMjQwNzQxIEwxNjYuNjc1NTIsNDUwLjI0MDc0MSBaIE01NjAuMjYzODQsMTMuODEyODk4NyBDNDU1LjMxMTUyNyw0NC45MDkxNTgxIDMzNS4xNTcwMTYsMTI2LjQ1MzUyNSAzMzUuMTU3MDE2LDI1Ni45NTIwOTIgQzMzNS4xNTcwMTYsMzc2LjMwMzgxMSA0MTMuMjQ4MzA0LDQzOC43NDkxNDQgNDkwLjQwMjMxMyw0MzguNzQ5MTQ0IEM1NDEuOTUyNjIxLDQzOC43NDkxNDQgNTc3Ljk1NzgyNiw0MDcuMTAxMjg4IDU3Ny45NTc4MjYsMzYxLjc1NTQ1IEM1NzcuOTU3ODI2LDMzOS44NTI0NjcgNTY1LjIwMTY5NiwzMTguODIyODQ2IDU1OC45NjA3OTQsMzE3Ljc4ODYwMiBDNDk1LjI3MTU4OCwzMDIuNzM0NjExIDQyOS43OTkyNjgsMjg3LjI0Mzk0IDQyOS43OTkyNjgsMjE4LjM0MDMyOSBDNDI5Ljc5OTI2OCwxNTIuNDcwNDk5IDQ3OC4yODYyNzYsOTkuMTAzNTI2IDU3OC4wMDM1NDcsNTUuMzY2NTEwNyBMNTYwLjI2Mzg0LDEzLjgxMjg5ODcgWiBNNDkwLjQwMjMxMyw0NTAuMjQwNzQxIEM0MDcuNTc4OTEzLDQ1MC4yNDA3NDEgMzIzLjcyNjc5MywzODMuODY1MjgxIDMyMy43MjY3OTMsMjU2Ljk1MjA5MiBDMzIzLjcyNjc5MywxMTguMDQxNjc3IDQ1Mi4wNjUzNDMsMzIuNDI5Mjg0NiA1NjEuOTc4MzczLDEuMzU2MDA4MzYgTDU2Ni44MDE5MjgsMCBMNTkzLDYxLjQxMTA5MDMgTDU4Ny43MTkyMzcsNjMuNjYzNDQzMiBDNDg5LjE2Nzg0OSwxMDUuODM3NjAxIDQ0MS4yMjk0OTEsMTU2LjQyMzYwOCA0NDEuMjI5NDkxLDIxOC4zNDAzMjkgQzQ0MS4yMjk0OTEsMjc4LjE0MjU5NSA0OTkuNTAwNzcxLDI5MS45MzI1MTEgNTYxLjIwMTExOCwzMDYuNTI2ODM4IEM1NzYuMjIwNDMyLDMwOS4wMzIwMDYgNTg5LjM4ODA0OSwzMzkuMDAyMDg5IDU4OS4zODgwNDksMzYxLjc1NTQ1IEM1ODkuMzg4MDQ5LDQxMy4wMzA5NTIgNTQ3LjczNjMxNSw0NTAuMjQwNzQxIDQ5MC40MDIzMTMsNDUwLjI0MDc0MSBMNDkwLjQwMjMxMyw0NTAuMjQwNzQxIFoiCiAgICB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDQ1MC4yNCkiCiAgLz4KPC9zdmc+Cg==) no-repeat;
    -webkit-mask: url(data:image/svg+xml;base64,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) no-repeat;
    mask: url(data:image/svg+xml;base64,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) no-repeat;
    -webkit-mask-position: center;
    height: 100px;
    width: 100px;
    -webkit-mask-size: contain;

`
// const Svg = styled.div`
//   margin: 0 auto;
//   width: 150%;
//   position: absolute;
//   top: -25px;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   display: block;  
//   background: linear-gradient(to right, #07c5d1, #f134a8);
//   background-size: 150% 150%;
//   -webkit-animation: AnimationName 10s ease infinite;
//   -moz-animation: AnimationName 10s ease infinite;
//   animation: AnimationName 10s ease infinite;

//   @-webkit-keyframes AnimationName {
//       0%{background-position:0% 50%}
//       50%{background-position:100% 51%}
//       100%{background-position:0% 50%}
//   }
//   @-moz-keyframes AnimationName {
//       0%{background-position:0% 50%}
//       50%{background-position:100% 51%}
//       100%{background-position:0% 50%}
//   }
//   @keyframes AnimationName { 
//       0%{background-position:0% 50%}
//       50%{background-position:100% 51%}
//       100%{background-position:0% 50%}
//   }

//   -webkit-mask: url(${props => props.background}) no-repeat;
//   mask: url(${props => props.background}) no-repeat;
//   -webkit-mask-position: top;
// `

export default CaseStudyEntry
